import { useMemo, useContext, useState, useCallback, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { AppAlert } from "../../../utils/AppAlert";
import { ReactComponent as DescriptionIcon } from "../../../icons/description.svg";
import { ReactComponent as OfflineIcon } from "../../../icons/offline.svg";
import { ReactComponent as BatteryIcon } from "../../../icons/battery.svg";
import { ReactComponent as CompanyIcon } from "../../../icons/company.svg";
import { ReactComponent as OnlineIcon } from "../../../icons/online.svg";
import { ReactComponent as AlarmIcon } from "../../../icons/alarm.svg";
import { ReactComponent as DateIcon } from "../../../icons/date.svg";
import { ReactComponent as GpsIcon } from "../../../icons/gps.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as EmailsMenuIcon } from "../../../icons/email-menu.svg";
import { ReactComponent as DevicesMenuIcon } from "../../../icons/devices-menu.svg";
import { ReactComponent as UsersMenuIcon } from "../../../icons/users-menu.svg";
import { ReactComponent as CompaniesMenuIcon } from "../../../icons/company-menu.svg";
import { ReactComponent as MessagesMenuIcon } from "../../../icons/messages-menu.svg";
import { ReactComponent as PhoneNumberMenuIcon } from "../../../icons/phone-number-menu.svg";
import { ReactComponent as ConfirmPhoneNumberIcon } from "../../../icons/confirmPhoneNumber.svg";
import { ReactComponent as EmailIcon } from "../../../icons/email-settings.svg";
import { ReactComponent as Error } from "../../../icons/x-circle.svg";
import { ReactComponent as Ok } from "../../../icons/check-circle.svg";
import { ConfirmPhoneNumber } from '../../common' ;
import { ApiError } from "../../../services/ApiError";
import PhoneInput from 'react-phone-number-input';
import Select from "react-select";
import config from "../../../config";
import "./deviceInfo.css";

function DeviceInfo() {
  const [open, setOpen] = useState(true);
  const [device, setDevice] = useState(false);
  const [status, setStatus] = useState(null);
  const [alarms, setAlarms] = useState(null);
  const [menu, setMenu] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const isConfirmedDeleting = inputValue.toLowerCase() === "delete";
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const menuDevicesRef = useRef(null);
  const [companies, setCompanies] = useState([]);
  const [actions, setActions] = useState([]);
  const [triggers, setTriggers] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [selectedTriggers, setSelectedTriggers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableCompanies, setAvailableCompanies] = useState("");
  const [availableUsers, setAvailableUsers] = useState("");
  const [availableDevices, setAvailableDevices] = useState("");
  const [emailNotifications, setAvailableEmailNotifications] = useState("");
  const [messagesNotifications, setAvailablemMssagesNotifications] = useState("");
  const [phoneCallsNotifications, setAvailablePhoneCallsNotifications] = useState("");
  const {infrastructureService, dataService, notificationService} = useContext(ServiceContext);
  const [selectedId, setSelectedId] = useState(1);
  const [ruleId, setRuleId] = useState(0);
  const [hiddenButtons, setHiddenButtons] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberConfirmed, setPhoneNumberConfirmed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [user, setUser] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const userRole = localStorage.getItem("user_role");
  const Global_Admin_Role = "Global Admin";
  const [isOpenCompanies, setIsOpenCompanies] = useState(false);
  const [targetCompanyId, setTargetCompanyId] = useState(null);
  const [moveDeviceId, setMoveDeviceId] = useState(null);

async function saveClick() {
  try {
    await infrastructureService.patch("Device/move", {
      id: moveDeviceId,
      targetCompanyId: targetCompanyId
    });

    setIsOpenCompanies(false);
    let device = {
          deviceId: deviceId
        };
        try {
          setLoading(true);
          const data = await infrastructureService.get("Device", device); 
          setDevice(data);
        } catch (error) {
          console.error("Error fetching device:", error);
        } finally {
          setLoading(false);
        }
  } catch (error) {
    console.error(error);
  }
}

  const roleOptions = useMemo(() => {
    if (userRole === Global_Admin_Role) {
      return [
        { value: "global_admin", label: "Global Admin" },
        { value: "company_admin", label: "Company Admin" },
      ];
    } else {
      return [
        { value: "company_admin", label: "Company Admin" },
      ];
    }
  }, [userRole]);
  
  const { deviceId } = useParams();
  
  const repeatHoldTimeMinutesList = useMemo(
    () => [
      { id: 1, name: "Do not repeat", value: 0 },
      { id: 3, name: "30 minutes", value: 30 },
      { id: 4, name: "1 hour", value: 60 },
      { id: 5, name: "2 hours", value: 120 },
      { id: 6, name: "4 hours", value: 240 },
      { id: 7, name: "8 hours", value: 480 },
      { id: 8, name: "16 hours", value: 960 },
      { id: 9, name: "24 hours", value: 1440 },
    ],
    [] 
  );

  const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#f5f5f5",
    borderColor: state.isFocused ? "#c7c4c4ff" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 2px #b1aeaeff" : "none",
    "&:hover": { borderColor: "#3f3f3fff" },
    borderRadius: "8px",
    padding: "0 4px",       
    minHeight: "45px",      
    width: "100%"
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "45px",         
    padding: "0 6px",
    alignItems: "center",  
    justifyContent: "center",  
    paddingBottom: "10px" 
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    height: "100%"
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#525050"
      : state.isFocused
      ? "#ebe8e8ff"
      : "white",
    color: state.isSelected ? "white" : "#525050",
    padding: "5px 10px",   
    cursor: "pointer",
    fontWeight: state.isSelected ? "bold" : "normal",
    transition: "background-color 0.1s ease",
    ":active": {
      backgroundColor: "#525050",
      color: "white"
    }
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#888",
    fontStyle: "italic",
    textAlign: "center",
    margin: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#222",
    margin: 0,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#3f3f3fff" : "#999",
    "&:hover": { color: "#3f3f3fff" }
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    overflow: "hidden",
    marginTop: "4px",
    boxShadow: "0 4px 12px #525050"
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0
  })
};

  const navigate = useNavigate();  
  
  const handleChange = (e) => {
    setSelectedId(Number(e.target.value))
    setHiddenButtons(false);
  };  
  
  const handleActionsToggle = (actionId) => {
    setSelectedActions((prev) =>
      prev.includes(actionId)
        ? prev.filter((id) => id !== actionId) 
        : [...prev, actionId] 
    );
    setHiddenButtons(false);
  };  
  
  const handleTriggersToggle = (triggerId) => {
    setSelectedTriggers((prev) =>
    prev.includes(triggerId)
      ? prev.filter((id) => id !== triggerId) 
      : [...prev, triggerId] 
  );
    setHiddenButtons(false); 
  };
  
  async function cancelClick() {
    setHiddenButtons(true);
    loadRule();
  }    
  
  async function savelClick() {
    setLoading(true);
    let editRule = {
        id: ruleId,
        deviceId: deviceId,
        repeatHoldTimeInterval: repeatHoldTimeMinutesList.find(item => item.id === selectedId)?.value ?? 0,
        ruleActions: selectedActions.map(id => ({ id })),
        ruleTriggers: selectedTriggers.map(id => ({ id }))
    };
    try {
      await notificationService.post("Rule", editRule);
      AppAlert.success("Success! Changes have been applied.");
    } catch (err) {
      console.error(err);
    }
    setHiddenButtons(true);
    loadRule();
    setLoading(false);
  } 
  
  async function confirmClick() {
    setIsOpenConfirm(true);
  }   
  
  function navigateToDeviceSettingsClick() {
    navigate("/device/" + deviceId);
  } 

  const handleLeftClick = (e) => {
    const clickX = e.clientX;
    const clickY = e.clientY;
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const menuW = 120; 
    const menuH = menuDevicesRef.current ? menuDevicesRef.current.offsetHeight : 120;

    let posX = clickX;
    let posY = clickY;
    
    if (clickX + menuW > screenW) {
      posX = screenW - menuW - 5;
    }
    
    if (clickY + menuH > screenH) {
      posY = screenH - menuH - 5;
    }

    setMenu({ x: posX, y: posY });
  };  
  
  function deleteDeviceClick() {
    setIsOpen(true);
  }
  
  const loadRule = useCallback(async () => {
    try {
      setLoading(true);
      let getRule = {
        deviceId: deviceId
      };
      const data = await notificationService.get("Rule", getRule); 
      setRuleId(data.id);
      setSelectedId(repeatHoldTimeMinutesList.find(item => item.value === data.repeatHoldTimeInterval)?.id  ?? 1);
      setSelectedActions(data.ruleActions.map(item => item.actionTypeId));
      setSelectedTriggers(data.ruleTriggers.map(item => item.triggerTypeId));
    } catch (error) {
      console.error("Error fetching rule:", error);
    } finally {
      setLoading(false);
    }
  }, [notificationService, deviceId, repeatHoldTimeMinutesList]);

  const loadTriggers = useCallback(async () => {
    try {
      setLoading(true);
      let getTriggers = {
        fromIndex: 0,
        itemsCount: config.uiSettings.itemsPerPage
      };
      const data = await notificationService.get("Triggers", getTriggers); 
      setTriggers(data.items);
    } catch (error) {
      console.error("Error fetching triggers:", error);
    } finally {
      setLoading(false);
    }
  }, [notificationService]);

  const loadActions = useCallback(async () => {
    try {
      setLoading(true);
      let getActions = {
        fromIndex: 0,
        itemsCount: config.uiSettings.itemsPerPage
      };
      const data = await notificationService.get("Actions", getActions); 
      setActions(data.items);
    } catch (error) {
      console.error("Error fetching actions:", error);
    } finally {
      setLoading(false);
    }
  }, [notificationService]);

  const loadCompanies = useCallback(async () => {
    try {
      setLoading(true);
      let getCompanies = {
        filter: "",
        showBlocked: false,
        fromIndex: 0,
        itemsCount: config.uiSettings.itemsPerPage
      };
      const data = await infrastructureService.get("Companies", getCompanies); 
      setCompanies(data.items);
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setLoading(false);
    }
  }, [infrastructureService]);

  const loadStatus = useCallback(async () => {
    try {
        const data = await dataService.get(`DeviceStatus?deviceId=${deviceId}`);
        setStatus(data);
    } catch (err) {} 
  }, [dataService, deviceId]);

  const loadAlarms = useCallback(async () => {
    try {
        const data = await dataService.get(`DeviceAlarm?deviceId=${deviceId}`);
        setAlarms(data);
    } catch (err) {} 
  }, [dataService, deviceId]);
  
  const fetchUser =  useCallback(async () =>  {
        const token = localStorage.getItem("access_token");
        const userId = getUserIdFromToken(token);
        if (!userId) {
          return;
        }
  
        try {
          const data = await infrastructureService.get("User", { userId });
          setPhoneNumber(data.phoneNumber);
          setPhoneNumberConfirmed(data.phoneNumberConfirmed);
          if(phoneNumber== null){
            setUser(data);
            setFirstName(data.firstName);
            setLastName(data.lastName);
            setEmail(data.email);
            const firstRole = data.roles?.find((c) => c);
            setRole(firstRole);
            setRole(roleOptions.find((opt) => opt.label === firstRole));
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
  }, [infrastructureService, phoneNumber, roleOptions]);
  
  useEffect(() => {
    const fetchDevice = async () => {
        let device = {
          deviceId: deviceId
        };
        try {
          setLoading(true);
          const data = await infrastructureService.get("Device", device); 
          setDevice(data);
          setAlarms(data.lastAlarmInfo);
        } catch (error) {
          console.error("Error fetching device:", error);
        } finally {
          setLoading(false);
        }
    };
    fetchDevice();
    loadActions();
    loadTriggers();
    loadRule();
    loadCompanies();
  }, [infrastructureService, deviceId, loadCompanies, loadActions, loadTriggers, loadRule]);

  const loadStatisticSummary = useCallback(async () => {
    try {
      setLoading(true);
       const data = await infrastructureService.get("Statistic"); 
       setAvailableCompanies(data.availableCompanies);
       setAvailableDevices(data.availableDevices);
       setAvailableUsers(data.availableUsers);
       setAvailableEmailNotifications(data.emailNotifications);
       setAvailablemMssagesNotifications(data.smsNotifications);
       setAvailablePhoneCallsNotifications(data.phoneCallsNotifications);
    } catch (error) {
       console.error("Error fetching statistic summary:", error);
    } finally {
      setLoading(false);
    }
  }, [infrastructureService]);

  useEffect(() => {
     loadStatisticSummary();
     loadStatus();  
     fetchUser();
     const intervalStatusId = setInterval(loadStatus, config.uiSettings.refreshTimeOfRequest);
     const intervalAlarmsId = setInterval(loadAlarms, config.uiSettings.refreshTimeOfRequest);
     return () => {
      clearInterval(intervalStatusId);
      clearInterval(intervalAlarmsId);
    };
  }, [loadStatisticSummary, loadStatus, loadAlarms, fetchUser]);
  

const handleConfirmChanged = async() => {
    const token = localStorage.getItem("access_token");
        const userId = getUserIdFromToken(token);
        if (!userId) {
          return;
        }
  
        try {
          const data = await infrastructureService.get("User", { userId });
          setPhoneNumber(data.phoneNumber);
          setPhoneNumberConfirmed(data.phoneNumberConfirmed);
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
};

  const getChannelNameById = (id) =>
    device?.alarmChannels?.find(c => c.alarmChannelId === id)?.name || null;

  async function okClick() {
    setLoading(true);
    let device = { deviceId: deviceId };
    try {
       await infrastructureService.delete("Device", device);
       AppAlert.success("Device was deleted successfully");
       navigate(-1); 
    } catch (error) {
       AppAlert.error("Device deletion error");
    } finally {
        setLoading(false);
    }
    setIsOpen(false);
  } 

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuDevicesRef.current &&
        !menuDevicesRef.current.contains(e.target) &&
        !e.target.closest(".menu-trigger") 
      ) {
        setMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
    
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);  

  const getUserIdFromToken = (token) => {
    if (!token) return null;
    try {
      const payload = token.split(".")[1];
      const decoded = JSON.parse(atob(payload));
      return decoded.user_id || null;
    } catch (e) {
      console.error("Invalid token:", e);
      return null;
    }
  };

  function validateUser({ userName, firstName, lastName}) {
    if (!userName || userName.trim() === "") {
      setErrorMessage("User name is required");
      return false;
    }
    if (!firstName || firstName.trim() === "") {
      setErrorMessage("First name is required");
      return false;
    }
    if (!lastName || lastName.trim() === "") {
      setErrorMessage("Last name is required");
      return false;
    } 
    if (!role) {
      setErrorMessage("Role is required");
      return false;
    }
    return true;
  }

  async function okUserClick() {
      let updateUser = {
        id: user.id,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        roles: [role.label]
      };
      if (!validateUser(updateUser)) return;
      try {
         await infrastructureService.put("User", updateUser);
         AppAlert.success("The user was changed successfully");
         fetchUser();
         setIsEdit(false)
        } 
      catch (err) {
           if (err instanceof ApiError) {
            if (err.errors) {
              setErrorMessage(Object.values(err.errors).flat().join("\n"));
            } else {
              setErrorMessage(err.message);
            }
          } else {
            setErrorMessage(err.message || "Unexpected error");
          }
        }
  } 

  if (loading) return <div>Loading...</div>;

  return (   
     <div>
        <div className="div-menu">
            <div onClick={() => setOpen(true)} className="menu-button">
                <label><svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                                         0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                </svg></label>
            </div>
            {open && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="col-span-12 h-full rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-gray-100 md:col-span-3 lg:col-span-2 modal-content-div">
                        <div className="close-modal" onClick={() => setOpen(false)}>
                            <MenuIcon/>
                       </div>
                       <div className="space-y-6">
                          <div>
                              <p className="px-2 text-sm font-semibold text-gray-600">Overview</p>
                              <div className="mt-2 space-y-1">
                                <Link className="link-item" to="/">
                                   <label className="link-lab"> 
                                      <CompaniesMenuIcon/> Companies
                                      <label className="label-float-end">{availableCompanies}</label>
                                   </label>
                                </Link>
                                <Link className="link-item" to="/users">
                                   <label className="link-lab">
                                       <UsersMenuIcon/> Users
                                       <label className="label-float-end">{availableUsers}</label>
                                   </label>
                                </Link>
                                <Link className="link-item" to="/devices">
                                   <label className="link-lab">
                                      <DevicesMenuIcon/> Devices
                                      <label className="label-float-end">{availableDevices}</label>
                                  </label>
                                </Link>
                              </div>
                              <hr/>
                           </div>
                           
                           <div className="pt-2">
                              <p className="px-2 text-sm font-semibold text-gray-600">Notifications</p>
                              <div className="mt-2 space-y-1">
                                <Link className="link-item" to="/emails">
                                  <label className="link-lab">
                                    <EmailsMenuIcon/> Emails
                                    <label className="label-float-end">{emailNotifications}</label>
                                  </label>
                                 </Link>
                                <Link className="link-item" to="/messages">
                                   <label className="link-lab">
                                      <MessagesMenuIcon/> Messages
                                      <label className="label-float-end">{messagesNotifications}</label>
                                    </label>
                                </Link>
                                <Link className="link-item" to="/phoneCalls">
                                   <label className="link-lab">
                                     <PhoneNumberMenuIcon/> Phone Calls
                                     <label className="label-float-end">{phoneCallsNotifications}</label>
                                   </label>
                                </Link>
                              </div>
                              <hr/>
                           </div>
                           
                           <div className="pt-2">
                              <div>
                                <div style={{  display: "inline-block"}}>
                                    <p className="px-2 text-sm font-semibold text-gray-600">Device Details</p>
                                </div>
                                <div style={{  display: "inline-block", float:"right", fontSize:"20px", cursor: "pointer"}} onClick={() => navigate("/devices")}>
                                   <p className="px-2 text-sm font-semibold text-gray-600"> X </p>
                                </div>
                              </div>
                              <div className="mt-2 space-y-1">
                                <Link className="link-item-selected" to={`/deviceInfo/${deviceId}`}>
                                  <label>
                                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 
                                                 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 
                                                 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                      </svg> General Information 
                                  </label>
                                </Link>
                                <Link className="link-item" to={`/statuses/${deviceId}`}>
                                   <label>
                                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                         <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 
                                                  1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 
                                                  7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 
                                                  .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 
                                                  1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 
                                                  2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
                                         <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
                                         <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
                                      </svg> Status History
                                    </label>
                                </Link>
                                <Link className="link-item" to={`/alarms/${deviceId}`}>
                                   <label>
                                     <svg fill="currentColor" width="20" height="20" viewBox="-50 -150 550 550">
                                        <g id="XMLID_140_">
                                            <g>
                                                <g>
                                                    <path d="M326.39,233.237v-30.34c0-48.263-33.197-88.766-78-99.938V72.124c0-13.807-11.193-25-25-25s-25,11.193-25,25v30.835 
                                                              c-44.803,11.172-78,51.675-78,99.938v30.34c0,32.437-12.886,63.546-35.822,86.483c-10.082,10.082-13.098,25.244-7.642,38.417 
                                                              c5.456,13.172,18.31,21.761,32.568,21.761h62.148c0,28.579,23.168,51.747,51.747,51.747c28.579,0,51.747-23.168,51.747-51.747 
                                                              h62.148c14.258,0,27.112-8.589,32.568-21.761c5.456-13.173,2.44-28.335-7.642-38.417 C339.275,296.783,326.39,265.674,326.39,233.237z"/>
                                                    <path d="M86.146,233.065c7.842-2.671,12.034-11.193,9.362-19.035c-8.021-23.55-6.392-48.815,4.589-71.14 
                                                              c10.98-22.325,29.998-39.037,53.548-47.058c7.842-2.671,12.034-11.193,9.362-19.036c-2.671-7.842-11.193-12.034-19.035-9.362 
                                                              c-31.136,10.605-56.278,32.7-70.795,62.215c-14.517,29.516-16.672,62.918-6.066,94.053 C69.782,231.546,78.306,235.736,86.146,233.065z"/>
			                                        <path d="M130.078,44.416c7.842-2.671,12.034-11.193,9.363-19.035c-2.671-7.842-11.194-12.033-19.036-9.362
                                                              C27.665,47.606-22.086,148.755,9.503,241.496c2.671,7.843,11.195,12.033,19.035,9.362c7.842-2.671,12.034-11.193,9.362-19.035
                                                            c-12.718-37.34-10.134-77.397,7.276-112.794C62.586,83.633,92.738,57.134,130.078,44.416z"/>
			                                        <path d="M302.806,67.434c-7.844-2.673-16.364,1.521-19.035,9.362c-2.671,7.842,1.521,16.364,9.362,19.036
				                                              c48.616,16.559,74.696,69.582,58.137,118.198c-2.671,7.842,1.52,16.364,9.362,19.035c7.836,2.671,16.363-1.517,19.035-9.362
				                                             C401.561,159.428,367.081,89.326,302.806,67.434z"/>
			                                       <path d="M428.523,105.788c-20.947-42.587-57.225-74.468-102.149-89.77c-7.844-2.674-16.364,1.521-19.035,9.362
				                                            c-2.671,7.842,1.521,16.364,9.362,19.035c37.34,12.719,67.492,39.217,84.902,74.613c17.41,35.397,19.994,75.454,7.275,112.794
				                                            c-2.671,7.842,1.521,16.364,9.362,19.035c7.836,2.671,16.363-1.517,19.035-9.362C452.578,196.57,449.47,148.375,428.523,105.788z"/>
		                                        </g>
	                                        </g>
                                       </g>
                                   </svg> Alarm History  
                                   </label>
                                </Link>
                              </div>
                              <hr/>
                           </div>
                           <div className="mx-2 h-px bg-gray-200"/>
                        </div>
                </div>
             </div>
          </div>
        )}
        </div>
        <div className='devices'>
            <div className="card-border">
                <div className="card-div">
                    <div className="div-inline-100">
                      <label onClick={(e) => handleLeftClick(e)}>
                        <svg width="35" height="35" fill="currentColor" viewBox="7 -15 10 30">
                           <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                              0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                        </svg><span className="lab-bold">Actions</span>
                      </label><br/><hr/>
                        <label>
                            <DescriptionIcon/><span className="span-bold">ESN</span><span>: {device.serialNumber}</span>
                        </label><br/>
                        <label>
                           <DescriptionIcon /><span className="span-bold">Type</span><span>: {device.nextGeneration ? "Next-Generation" : "Original"}</span>
                        </label><br />
                        <label>
                            <DescriptionIcon/><span className="span-bold">Name</span><span>: {device.name}</span>
                        </label><br/>
                        <label>
                            <DescriptionIcon/><span className="span-bold">Description</span><span>: {device.description}</span>
                        </label><br/>
                        <label>
                            <CompanyIcon/><span className="span-bold">Company</span><span>: {companies.find((c) => c.id === device.companyId)?.name || "—"}</span>
                        </label>
                    </div> 
                     {menu && (
                       <ul ref={menuDevicesRef}  onClick={() => setMenu(null)} className="context-menu" style={{ top: menu.y, left: menu.x, position: "fixed" }}>
                         <li onClick={() => navigateToDeviceSettingsClick()}>
                           <label>
                              <EditIcon/> Edit
                           </label>
                          </li> 
                           {(userRole !== undefined && userRole === Global_Admin_Role) && (
                            <li onClick={(e) => { setMoveDeviceId(device.id); setTargetCompanyId(device.companyId); setIsOpenCompanies(true); }}>
                              <label>  
                                <EditIcon/> Move
                              </label>
                            </li>
                          )}
                          <li>
                             <label onClick={() => {deleteDeviceClick(); setMenu(null);}}>
                                <DeleteIcon/> Delete
                             </label>                
                          </li>
                       </ul>
                     )} 
                     <div className="div-inline-100">
                        <label>
                            <span className="lab-bold">Connection Status: </span>
                            <span>
                              {!device?.isOnline && <OfflineIcon />}
                              {device?.isOnline && <OnlineIcon />}
                            </span>
                        </label>
                      </div>  
                {device?.alarmChannels !== null && (<div className="div-inline-100">
                   <label>
                      <label className="lab-bold">Channel Names: </label>  
                      <span className="span-bold span-margin-left">CH1: </span>
                      <span className="span-width-220">{getChannelNameById(1)}</span>
                      <span className="span-bold span-margin-left">CH2: </span>
                      <span className="span-width-220">{getChannelNameById(2)}</span>
                      <br/>
                      <span className="span-bold span-margin-left-120">CH3: </span>
                      <span className="span-width-220">{getChannelNameById(3)}</span>
                      <span className="span-bold span-margin-left-19">CH4: </span>
                      <span className="span-width-220">{getChannelNameById(4)}</span>
                   </label>
                </div> )}
                 <hr/>
                    <div className="div-inline-100" style={{ textAlign:"start" }}>
                         <div style={{ float: "left", width: "300px" }}>
                            <label className="lab-bold">Last Status</label><br/>
                               {status ? (<label>
                                   <label>
                                       <DateIcon/><span className="span-bold">Date-Time</span><span>: {status.lastStatusMsgDatetimeUtc ? new Date(status.lastStatusMsgDatetimeUtc + "Z").toLocaleString() : "No Statuses available yet"}</span>
                                   </label><br/>
                                   {status.gpsCoordinate ? (
                                      <label>
                                        <GpsIcon/><span className="span-bold">GPS: </span><span>
                                          <a href={status.gpsCoordinate ? `http://www.google.com/maps/place/${status.gpsCoordinate.gpsLatitude.toFixed(6)},${status.gpsCoordinate.gpsLongitude.toFixed(6)}` : "#" } target="_blank" rel="noopener noreferrer">
                                             {status.gpsCoordinate ? `${status.gpsCoordinate.gpsLatitude.toFixed(6)}, ${status.gpsCoordinate.gpsLongitude.toFixed(6)}` : "—"}</a></span>
                                      </label>
                                    ): (
                                      <label>
                                        <GpsIcon/><span className="span-bold">GPS</span><span>: No GPS available</span>
                                      </label>
                                    )}<br/>
                                    <label>
                                        <BatteryIcon />

                                        {device.nextGeneration ? (
                                            <>
                                                <span className="span-bold">Power Mode</span>
                                                <span>
                                                    : {status?.batteryStatus?.batteryOk ? "Normal" : "Low"}
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="span-bold">Battery</span>
                                                <span>
                                                    : {status?.batteryStatus?.batteryOk ? "OK" : "Low"}
                                                </span>
                                            </>
                                        )}
                                    </label><br/>
                                   {status.systemStatus ? (
                                      <label>{status.systemStatus?.systemOk ? <Ok/> : <Error/>}<span className="span-bold">Unit Status</span>{status.systemStatus?.systemOk ? <span>: Ok</span> : <span style={{color: "red"}}>: Error</span>}
                                      </label>
                                    ): (
                                       <label><Error/><span className="span-bold">Unit Status</span><span>: No unit status available</span></label>
                                    )}
                                </label>  ) : <label>No check-ins available</label>}
                         </div>
                         <div style={{ float: "left", width: "300px"}}>
                            <label className="lab-bold">Last Alarm</label><br/>
                                {alarms ? (<label>
                                    <label>
                                        <DateIcon/><span className="span-bold">Date-Time</span><span>: {alarms.lastAlarmMsgDatetimeUtc ? new Date(alarms.lastAlarmMsgDatetimeUtc + "Z").toLocaleString() : "No Alarms available yet"}</span>
                                    </label><br/>
                                    {alarms?.alarms?.some(alarm => alarm.status === true) ? (
                                      alarms.alarms.filter(alarm => alarm.status === true).map(alarm => (
                                        <label key={alarm.id}>
                                          <AlarmIcon /><span className="span-bold">{alarm.alarmChannelName}</span><span>: {alarm.deviceAlarmChannelName}</span>
                                        <br />
                                      </label>
                                    ))
                                  ) : (
                                    <p>No active alarms</p>
                                  )}

                                </label>) : <label>No alarms available</label>}
                         </div>
                    </div>
               <hr/>
               <div className="div-inline-100">
                  <label className="lab-bold" style={{paddingLeft: "5px"}}>Notifications</label>
               </div>
               <div className="div-inline-100"> 
                  <label>
                     <span className="span-bold" style={{paddingLeft: "5px"}}>Repeat Interval</span>
                     <span> : </span>
                     <span>
                        <select style={{ width: "200px" }} value={selectedId} onChange={handleChange}>
                                   {repeatHoldTimeMinutesList.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                        </select>
                     </span>
                  </label>
               </div>
               <div className="div-inline-100" style={{ textAlign:"start" }}>
                 <div style={{ float: "left", width: "300px" }}>
                     <label className="span-bold" style={{paddingLeft: "5px"}}>
                        Triggers:
                     </label><br/>
                    {triggers != null && triggers.length > 0 ? ( triggers.map((trigger) => { 
                      const inputId = "trigger" + trigger.id;
                      return (
                        <label key={trigger.id} style={{ whiteSpace: "nowrap" }}>
                          <label className="toggle-switch">
                            <input className="toggle-input" id={inputId} type="checkbox" 
                                   checked={selectedTriggers.includes(trigger.id)} 
                                   onChange={() => handleTriggersToggle(trigger.id)}/>
                            <label className="toggle-label" htmlFor={inputId}></label>
                            <span className="toggle-label-text">{trigger.name}</span>
                          </label><br />
                        </label>
                      );})
                      ) : (
                         <p>No triggers available.</p>
                      )}
                 </div>
                 <div style={{ float: "left"}}>
                    <label className="span-bold" style={{paddingLeft: "5px"}}>
                        <span> Actions: </span>
                    </label><br/>
                    {actions != null && actions.length > 0 ? ( actions.map((action) => { 
                      const inputId = "action" + action.id;
                      return (
                        <label key={action.id} style={{ whiteSpace: "nowrap" }}>
                          <label className="toggle-switch">
                            <input className="toggle-input" id={inputId} type="checkbox" 
                                   checked={selectedActions.includes(action.id)} 
                                   onChange={() => handleActionsToggle(action.id)}/>
                            <label className="toggle-label" htmlFor={inputId}></label>
                            <span className="toggle-label-text">{action.name}</span>
                          </label>
                          <br />                         
                        </label>
                      );})
                      ) : (
                         <p>No actions available.</p>
                      )}
                      {(selectedActions.includes(2) || selectedActions.includes(3)) && (
                           <div>
                             {(!phoneNumberConfirmed && phoneNumber !== null) &&(<div>
                              It appears that your phone number hasn't been confirmed yet, so we can’t call or send you SMS messages until you opt in. 
                              <div style={{ height: "30px",borderRadius:"8px",fontSize:"16px", width:"auto", maxWidth:"230px" }}
                                   className="cancel" onClick={confirmClick}>
                                <span style={{paddingTop:"7px", paddingRight:"5px", fontWeight:"bold"}}><ConfirmPhoneNumberIcon/></span>Confirm phone number
                              </div>
                            </div>)}
                            {(!phoneNumberConfirmed && phoneNumber === null) &&(<div>
                              It appears that your phone number hasn't been added.
                              <div style={{ height: "30px",borderRadius:"8px",fontSize:"16px", width:"auto", maxWidth:"230px" }}
                                   className="cancel" onClick={() => setIsEdit(true)}>
                                    Add phone number
                              </div>
                            </div>)}
                           </div>
                          )}
                 </div>
               </div>
               {!hiddenButtons && (<div className="div-inline-100" style={{ textAlign:"start" }}>
                 <div style={{ float: "left", width: "300px" }}>
                    <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={cancelClick}>Cancel</div>
                 </div>
                 <div style={{ float: "left", width: "300px"}}>
                    <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={savelClick}>Save changes</div>
                 </div>
               </div>)}
                </div>
            </div>
        </div>

      {isOpen && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor: "white",borderRadius: "8px",width: "300px",boxShadow: "0 5px 15px rgba(0,0,0,0.3)",textAlign:"start"}}>
              <div style={{background:"rgb(236, 236, 236)"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px",textAlign:"center" }}>Delete device</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <p style={{ marginBottom: "20px" }}>Do you want to delete the device? <br/><br/>Note: The device will be deleted without the possibility of restoration.</p>
                <p>To confirm deletion, enter <span style={{fontWeight:"600", fontStyle:"italic"}} className="fst-italic fw-bold">delete</span> in the text input field.</p>
                <div style={{textAlign:"center"}}>
                  <input placeholder="delete" value={inputValue} onChange={(e) => setInputValue(e.target.value)}  style={{ marginBottom: "10px", width: "240px", padding: "5px" }}/>
                </div>
                <div>
                  {!isConfirmedDeleting && (
                    <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                      <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                      <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }}>Ok</div>
                    </div>
                  )}
                  {isConfirmedDeleting && (
                    <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                      <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                      <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => okClick()}>Ok</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
         </div>
      )}

      {!isEdit && (<ConfirmPhoneNumber isOpenConfirm={isOpenConfirm} setIsOpenConfirm={setIsOpenConfirm} phoneNumber={phoneNumber} onConfirmed={handleConfirmChanged}/>)}

      {isEdit && (
        <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor: "white",borderRadius: "8px",width: "500px",boxShadow: "0 5px 15px rgba(0,0,0,0.3)",}}>
              <div style={{background:"rgb(236, 236, 236)"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>User Settings</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                
                      <div>
                        <div>
                          <div className="inputs" style={{marginTop:"10px"}}>
                            <div className="input">
                              <DescriptionIcon/>
                              <input placeholder="First name" onChange={(e) => setFirstName(e.target.value)} value={firstName}/>
                            </div>
                            <div className="input">
                              <DescriptionIcon/>
                               <input placeholder="Last name" onChange={(e) => setLastName(e.target.value)} value={lastName}/>
                            </div>
                            <div className="input">
                              <EmailIcon/>
                              <input type="email" placeholder="Email" disabled={true} onChange={(e) => setEmail(e.target.value)} value={email}/>
                            </div>
                            <div className="input">
                              <div style={{paddingLeft: "30px"}}>
                                <PhoneInput placeholder="Phone number " defaultCountry="US" value={phoneNumber} onChange={setPhoneNumber}/>
                              </div>
                            </div>
                            <div className="input settings-select">
                              <div className="select-company-u">
                                 <Select isSearchable={true} placeholder="Please select a role" styles={customStyles} options={roleOptions} value={role} 
                                         onChange={(selectedOption) => setRole(selectedOption)} isDisabled={true}/>
                              </div>
                            </div>
                            {errorMessage && (
                              <div className="error input">
                                <span style={{paddingLeft: "10px"}}>{errorMessage}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                          <div className="cancel-user-info" onClick={() => setIsEdit(false)}>Cancel</div>
                          <div className="submit-user-info" onClick={() => okUserClick()}>Save</div>
                        </div>
                      </div>
              </div>
            </div>
         </div>
      )}

{isOpenCompanies && (
  <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000, background:"rgba(0,0,0,0.3)" }}>
    <div style={{ backgroundColor:"white", borderRadius:"8px", width:"100%", maxWidth:"550px", maxHeight:"80vh", display:"flex", flexDirection:"column", boxShadow:"0 5px 15px rgba(0,0,0,0.3)" }}>
      
      <div style={{ background:"rgb(236,236,236)", padding:"10px" }}>
        <h2 style={{ margin:0, padding:"13px 0" }}>Move device</h2>
      </div>

      <div style={{ padding:"10px", overflowY:"auto", flex:1 }}>
        {loading && <div>Loading...</div>}

        {!loading && (
          <>
            {companies?.length > 0 ? companies.map((company) => (
              <div key={`company-${company.id}`} style={{ border:"1px solid rgb(230,230,230)", borderRadius:"10px", cursor:"pointer", padding:"10px", display:"flex", alignItems:"center", gap:"10px", marginBottom:"8px" }} onClick={() => setTargetCompanyId(Number(company.id))}>
                <input type="radio" name="company" checked={targetCompanyId === Number(company.id)} onChange={() => setTargetCompanyId(Number(company.id))} style={{ margin:0 }} />
                <span>{company.name}</span>
              </div>
            )) : <p>No companies available.</p>}
          </>
        )}
      </div>

      <div className="submit-container" style={{ padding:"10px", borderTop:"1px solid #eee" }}>
        <div className="cancel" style={{ height:"30px", borderRadius:"8px", fontSize:"16px" }} onClick={() => setIsOpenCompanies(false)}>Cancel</div>
        <div className="submit" style={{ height:"30px", borderRadius:"8px", fontSize:"16px" }} onClick={saveClick}>Save</div>
      </div>

    </div>
  </div>
)}

     </div> 
  );
}

export default DeviceInfo;